(function () {
  'use strict';

  angular
    .module('web2print')
    .filter('formatMaxDimensions', formatMaxDimensions);

  function formatMaxDimensions () {
    return formatMaxDimensionsFilter;

    function formatMaxDimensionsFilter (input) {
      if (!input) return;

      return _.compact(_.pluck(input, 'max')).join(' × ');
    }
  }
})();
